import { Component, OnInit } from '@angular/core';
import { AdmindasboardservicesService } from '../shared/services/admindasboardservices.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SharedModeService } from '../shared/services/shared-mode.service';
import { CommonModule, DatePipe } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { OneSignal } from 'onesignal-ngx';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { NewsUpdatesComponent } from '../shared/components/news-updates/news-updates.component';
interface MediaItem {
  file_extension: string;
  media_image_url: string;
  // Add other properties as needed
}
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, LottieComponent, NewsUpdatesComponent],
  providers: [DatePipe],
})

export class AdminDashboardComponent implements OnInit {

  public user: any = [];
  public checkInStatus: any = '';
  public checkInTime = '';
  public taskexist = false;
  public showSpinner = true;
  public leaves: any[] = [];
  public checkData: any = [];
  public years_count = 0;


  public anniversary_count: any;


  private runningTimer: any;

  options: AnimationOptions = {
    path: '../../assets/welcom_animation.json',
  };
  cake: AnimationOptions = {
    path: '../../assets/Cake.json',
  };
  Attendance: AnimationOptions = {
    path: '../../assets/Attendance.json',
  };
  HeadCount: AnimationOptions = {
    path: '../../assets/HeadCount.json',
  };
  Leaves: AnimationOptions = {
    path: '../../assets/Leaves.json',
  };
  Loan: AnimationOptions = {
    path: '../../assets/Loan.json',
  };
  phone: AnimationOptions = {
    path: '../../assets/phone.json',
  };
  email_anim: AnimationOptions = {
    path: '../../assets/email.json',
  };
  address_anim: AnimationOptions = {
    path: '../../assets/address.json',
  };


  userInfo: any;
  birthday: any;

  counter: any;
  first_name: any;
  last_name: any;
  total_user: any;
  total_web_user: any;
  total_mob_user: any;
  total_graphic_user: any;
  total_business_user: any;
  total_leaves: any;
  total_paid_leaves: any;
  total_unpaid_leaves: any;
  total_absent: any;
  profile_image: any;
  evalution: any;
  evaluation_point: any;
  total_attendance_req: any;
  total_loan_request_count: any;

  selectedMode: any;
  datamode: any;
  event: any;
  eventDate: any;
  eventImageUrl: any;
  total_other: any;
  isPopupVisible = false;
  colormode: any;
  media_path: any;
  media_url: string[] = [];
  // isVideoFileExtension: any;
  imageUrl: any;
  address: any;
  refresh: any;
  mediaObject: any[] = [];
  isNewsUpdateShow = false;
  isMedia = false;
  isNewsUpdateModalShow = true;

  fakeUsers = [
    { user: null, pm_points: 0 },
    { user: null, pm_points: 0 },
    { user: null, pm_points: 0 }
  ];
  deparment_name_first: any;
  deparment_user_count_first: any;
  deparment_name_second: any;
  deparment_user_count_second: any;
  deparment_name_third: any;
  deparment_user_count_third: any;
  deparment_name_fourth: any;
  deparment_user_count_fourth: any;

  constructor(
    private admindasboardServices: AdmindasboardservicesService,
    public router: Router,
    private route: ActivatedRoute,
    private sharedmode: SharedModeService,
    private datePipe: DatePipe,
    public dashboardService: DashboardService,
    private oneSignal: OneSignal
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    this.setupuser(this.user);
    this.user_refresh();

    this.getData();

  }
  get usersToDisplay() {
    const realUsersCount = this.evalution ? this.evalution.length : 0;
    const fakeUsersNeeded = 3 - realUsersCount;
    return [
      ...(this.evalution || []),
      ...this.fakeUsers.slice(0, fakeUsersNeeded)
    ];
  }
  getUser(): any {
    if (this.userInfo == null) {
      return this.user
    } else {
      return this.userInfo
    }
  }

  Running() {
    const countDownDate = new Date(this.user.joining_date).getTime();

    this.anniversary_count = "1st"
    // Get today's date and time
    const now = new Date().getTime();
    let distance = now - countDownDate;
    distance = Math.abs(distance);
    let years_day = Math.floor(distance / (1000 * 60 * 60 * 24))
    years_day = Math.abs(years_day);
    // alert(years_day)
    if (years_day >= 365) {
      this.years_count = Math.floor(years_day / 365);
      years_day = years_day - (365.2 * this.years_count)
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    } else {
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    }
    const days = (years_day).toString();
    const hours = (24 - Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).toString();
    const minutes = (60 - Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).toString();
    const seconds = (60 - Math.floor((distance % (1000 * 60)) / 1000)).toString();
    if (days.length == 1) {
      $("#day-one").html('0');
      $("#day-two").html('0');
      $("#day-three").html(days[0]);
    } else if (days.length == 2) {
      $("#day-one").html('0');
      $("#day-two").html(days[0]);
      $("#day-three").html(days[1]);
    } else {
      $("#day-one").html(days[0]);
      $("#day-two").html(days[1]);
      $("#day-three").html(days[2]);
    }
    if (hours.length == 1) {
      $("#hour-one").html('0');
      $("#hour-two").html(hours[0]);
    } else {
      $("#hour-one").html(hours[0]);
      $("#hour-two").html(hours[1]);
    }
    if (minutes.length == 1) {
      $("#min-one").html('0');
      $("#min-two").html(minutes[0]);
    } else {
      $("#min-one").html(minutes[0]);
      $("#min-two").html(minutes[1]);
    }
    if (seconds.length == 1) {
      $("#sec-one").html('0');
      $("#sec-two").html(seconds[0]);
    } else {
      $("#sec-one").html(seconds[0]);
      $("#sec-two").html(seconds[1]);
    }

    // If the count down is over, write some text
    if (distance < 0) {
      clearInterval(this.runningTimer);
      $("#day-one").html("0");
      $("#day-two").html("0");
      $("#day-three").html("0");
      $("#hour-one").html("0");
      $("#hour-two").html("0");
      $("#min-one").html("0");
      $("#min-two").html("0");
      $("#sec-one").html("0");
      $("#sec-two").html("0");
    }


    if (this.years_count === 1) {
      this.anniversary_count = "2nd"
    } else if (this.years_count === 2) {
      this.anniversary_count = "3rd"
    } else if (this.years_count > 2) {
      this.anniversary_count = this.years_count + "th"
    }
  }
  ngOnInit(): void {
    this.user_detail();
    this.employees_detail();
    this.employees_evaluation();
    this.runningTimer = setInterval(() => { this.Running() }, 1000);
    $('#sidebar-wrapper').show();
    $('.navbar').show();
    $('.circle_animation').css('stroke-dashoffset', 1);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

    this.upcomingEvent()
  }





  getData() {

    this.dashboardService.getDashboardData().then((value) => {
      this.mediaObject = value?.media;
      if (value.media != null && value?.media != undefined && value?.media?.length > 0) {
        this.isNewsUpdateShow = true;
      }
      this.showSpinner = false;

      if (localStorage.getItem('userDeviceID_OneSignal_subcripptio') == "" || localStorage.getItem('userDeviceID_OneSignal_subcripptio') == null) {
        //Get ID for Onesignla External ID
        const userID = this.user?.id ?? "15500"
        this.oneSignal.login(String(userID)).then(value => {
          const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
          if (userDeviceID_OneSignal_subcripptio.length > 5) {
            localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
          }
        })
        const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
        if (userDeviceID_OneSignal_subcripptio.length > 5) {
          localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
        }
      }
    });
  }







  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

      localStorage.setItem('user', JSON.stringify(value.data.user));
      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user.user_role.user_roles)
      if (user_role.role_type != "Admin") {
        this.router.navigate(['/dashboard-1']);
      }
    })

  }




  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  getStrokeColor(): string {
    return this.selectedMode === 'dark' ? 'white' : '#1E1E1E';
  }

  setupuser(user: any) {
    this.address = user.address
    this.first_name = user.first_name
    this.last_name = user.last_name

    this.birthday = user.dob
    if (this.birthday) {
      const datePattern = /^\d{4}-\d{2}-\d{2}$/;
      if (datePattern.test(this.birthday)) {
        const date = new Date(this.birthday);
        const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' }; // Corrected options type
        this.birthday = date.toLocaleDateString('en-GB', options);
      }
      // If the date is already in "DD MMMM" format, no need to change it
    }
    this.profile_image = user.profile_image
    this.media_path = user.media?.path
    this.colormode = user.color_mode
    this.sharedmode.setMode(this.colormode);
    this.media_url = user.media?.media_image_url
    this.imageUrl = this.getImagePath() + '/' + (this.media_path || 'assets/images/question.jpg');

  }
  getImagePath(): string {
    return `${environment.imageBaseURL}`;
  }
  user_detail() {
    this.showSpinner = true;
    this.admindasboardServices.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.setupuser(this.userInfo);
      //   let arr=[];
      //   arr[0]=this.media_url;

      // for (let url of arr) {
      //   if(url?.includes('.png') || url?.includes('.jpeg') || url?.includes('.jpg') || url?.includes('.webp')) {
      //     this.imageUrl = url

      //   } else if (url?.includes('.mp4')) {
      //     this.imageUrl = 'assets/images/question.jpg'

      //   }
      //   else{
      //     this.imageUrl = 'assets/images/question.jpg'

      //   }
      // }



      this.showSpinner = false;
    })

  }
  isVideoFile(fileExtension: string): boolean {
    return fileExtension.toLowerCase() === '.mp4';
  }

  getMonthName(dateString: string): string {
    const date = new Date(dateString);
    const monthNames = [
      'January', 'February', 'March',
      'April', 'May', 'June', 'July',
      'August', 'September', 'October',
      'November', 'December'
    ];

    return monthNames[date.getMonth()];
  }

  employees_detail() {
    this.showSpinner = true;
    this.admindasboardServices.getemployeesDetail().then((value) => {
      this.counter = value.data
      this.total_user = this.counter.total_user_count
      this.deparment_name_first = this.counter.top_four[0]?.department_name
      this.deparment_user_count_first = this.counter.top_four[0]?.user_count
      this.deparment_name_second = this.counter.top_four[1]?.department_name
      this.deparment_user_count_second = this.counter.top_four[1]?.user_count
      this.deparment_name_third = this.counter.top_four[2]?.department_name
      this.deparment_user_count_third = this.counter.top_four[2]?.user_count
      this.deparment_name_fourth = this.counter.top_four[3]?.department_name
      this.deparment_user_count_fourth = this.counter.top_four[3]?.user_count
      this.total_leaves = this.counter.current_month_leave_count
      this.total_paid_leaves = this.counter.total_paid_leave_count
      this.total_unpaid_leaves = this.counter.total_unpaid_leave_count
      this.total_absent = this.counter.total_absent_leave_count
      this.total_attendance_req = this.counter.attendance_request_count
      this.total_loan_request_count = this.counter.loan_request_count
      this.total_other = this.counter.other_count

      this.showSpinner = false;
    })

  }

  employees_evaluation() {
    this.showSpinner = true;
    this.admindasboardServices.getemployeesevaluation().then((value) => {
      this.evalution = value.data
      this.evaluation_point = this.evalution.points
      this.showSpinner = false;
    })


  }

  upcomingEvent() {
    this.admindasboardServices.upcomingevent().then((value) => {
      this.event = value.data
      this.eventDate = this.event.event_date
      this.eventImageUrl = this.event.event_image
    })
  }

  togglePopup(data: any) {
    data.isPopupVisible = !data.isPopupVisible;
  }

  toggleOtherPopup() {
    this.isPopupVisible = !this.isPopupVisible;
  }

  handleImageError() {
    // Handle image error here
    this.eventImageUrl = 'assets/images/question.jpg'; // Replace with the actual path to your saic image
  }
}

